/**
 * Includes both start and end date in count [start, end] eg. 1.5.2023 - 3.5.2023 = 3
 * @param start  Starting date
 * @param end  Ending Date
 * @returns
 */

import { differenceInCalendarDays } from "date-fns";

export const countDaysInDateRange = (start: Date, end: Date) => {
  return differenceInCalendarDays(end, start) + 1;
};
